import * as actionTypes from '../actions/actionTypes'

const initialState = {
}

export default function reducer(state = initialState, action) {
  switch(action.type) {
    case actionTypes.SET_STYLES:
      return action.payload
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/ChatWidget/store/reducers/stylesReducer.js